import type { RouteRecordRaw } from 'vue-router'
import { RouteList } from '@/routes/RouteList'

const PublicSchedulerView = () => import('@/views/Public/Scheduler/PublicSchedulerView.vue')
const PublicSchedulerInlineView = () =>
  import('@/views/Public/Scheduler/PublicSchedulerInlineView.vue')

export const schedulerRoutes: RouteRecordRaw[] = [
  {
    path: RouteList.PUBLIC.SCHEDULER.PATH,
    name: RouteList.PUBLIC.SCHEDULER.NAME,
    component: PublicSchedulerView,
  },
  {
    path: RouteList.PUBLIC.SCHEDULER_INLINE.PATH,
    name: RouteList.PUBLIC.SCHEDULER_INLINE.NAME,
    component: PublicSchedulerInlineView,
  },
]
